import React, { useContext } from 'react';

import { ConditionalRendering } from '@components/common/conditional-rendering';
import Tooltip from '@components/common/tooltip/Tooltip';
import { usePermissions } from '@hooks/usePermissions';
import { getCurrency } from '@utils/tools/currencyTools';
import {} from '../../common/enrollmentUtils';
import { IEnrollmentPremiumDto } from '../../common/types';
import { EnrollmentContext } from '../../context/MemberMyEnrollmentProvider';

const ColumnNerPremium = ({ premium }: { premium: IEnrollmentPremiumDto }) => {
    const { enrollmentPremiumFormContext, selectedEnrollment } = useContext(EnrollmentContext);
    const { watch } = enrollmentPremiumFormContext;
    const values = watch();
    const {
        isNotApplicable,
        isNotEqualEffectiveDate,
        isPremiumMonthNotInOrignalEffectiveDate,
        isWithinEffectiveRange,
        isPremiumMonthInOrignalEffectiveDate,
    } = usePermissions();

    return (
        <>
            <ConditionalRendering isTrue={isNotApplicable(premium, values)}>
                <ConditionalRendering isTrue={isPremiumMonthInOrignalEffectiveDate(premium.month)}>
                    {getCurrency(premium.netPremiumAmount)}
                </ConditionalRendering>
                <ConditionalRendering isTrue={isPremiumMonthNotInOrignalEffectiveDate(premium.month)}>
                    <Tooltip
                        id="member.enrollment_list.premiumhistory.pendingCalculation"
                        elementId="pendingCalculation"
                        content="member.enrollment_list.premiumhistory.pendingCalculation.popup"
                        place="top"
                        dataAutomationId="pendingCalculation"
                    />
                </ConditionalRendering>
            </ConditionalRendering>
        </>
    );
};

export default ColumnNerPremium;
